export const environment = {
  production: false,
  //apiUrl: 'https://localhost:44304'
  //apiUrl: 'https://localhost:443',
  apiUrl: 'https://api.familitive.com',
  googleClientId: '47090723075-rrp49gjsju5alokuugh10f3oap0q3kcn.apps.googleusercontent.com'
};
